<template>
  <div v-if="constraint.removed!==true">
    <div class="row time-constraint mt-2">
      <div class="col-12">
        <div class="cf-input-group">
          <label>Początek/Koniec filmu</label>
          <select
            v-model="$props.constraint.type"
            class="form-select"
          >
            <option :value="0">
              Początek
            </option>
            <option :value="1">
              Koniec
            </option>
          </select>
        </div>
        <div class="cf-input-group">
          <label>Od</label>
          <input
            v-model="$props.constraint.start"
            type="time"
            class="form-control"
          >
          <div class="cf-input-group">
            <label>Do</label>
            <input
              v-model="$props.constraint.end"
              type="time"
              class="form-control"
            >
          </div>
          <cinema-button
            label="Usuń"
            @click="removeConstraint()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemaButton from '@/components/CinemaButton'

export default {
  name: 'TimeConstraint',
  components: {
    CinemaButton
  },
  props: {
    constraint: {
      type: Object,
      default: null
    },
    constraintKey: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  created () {
  },
  methods: {
    removeConstraint () {
      this.$emit('removeConstraint', this.$props.constraintKey)
    }
  }
}
</script>
